import { BannerContext } from 'components/Routes/BannerContext';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { FC, ReactNode, useContext } from 'react';
import { Project } from 'records/Project';
import SideNav from './SideNav';
import DefaultSideNavContent from './SideNav/DefaultSideNavContent';
import TopNav from './TopNav';
import DefaultTopNavContent from './TopNav/DefaultTopNavContent';

interface Props {
  topNavItems?: () => ReactNode;
  children: ReactNode;

  /**
   * Additional styling to apply.
   */
  className?: string;
}

const Navigation: FC<Props> = ({
  children,
  className,
  topNavItems = () => <DefaultTopNavContent />,
}) => {
  const { height } = useContext(BannerContext);
  const viewHeight = `calc(100vh - ${height}px)`;

  return (
    <div
      className={className ?? 'row'}
      style={{
        height: viewHeight,
        overflow: 'hidden',
      }}
    >
      <SideNav viewHeight={viewHeight}>
        <DefaultSideNavContent />
      </SideNav>
      <div className="column grow-1">
        <TopNav items={topNavItems} />
        <div className="flex flex-col grow" style={{ overflow: 'auto' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Navigation;
